/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";
import axios from "axios";

// @mui material components
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
// NewProduct page components
import FormField from "layouts/ecommerce/products/new-product/components/FormField";
import TextField from "@mui/material/TextField";
function Instruksi({ values, onChange }) {
  // Handler untuk input biasa
  const handleInputChange = (field) => (event) => {
    onChange({ [field]: event.target.value });
  };
  // Handler untuk Autocomplete
  const handleAutoChange = (field) => (event, value) => {
    onChange({ [field]: value || null });
  };
  // Handler untuk TextField
  const handleTextFieldChange = (event) => {
    if (typeof onChange === "function") {
      onChange({ isi_instruksi: event.target.value });
    }
  };

  return (
    <MDBox>
      <MDTypography variant="h5">Instruksi Detail</MDTypography>
      <MDBox mt={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField
              type="text"
              label="Perihal"
              value={values.perihal}
              onChange={handleInputChange("perihal")}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <FormField
              type="datetime-local"
              label="Start"
              value={values.tanggal}
              onChange={handleInputChange("tanggal")}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <FormField
              type="datetime-local"
              label="Finish"
              value={values.tanggal_selesai}
              onChange={handleInputChange("tanggal_selesai")}
            />
          </Grid>
        </Grid>
      </MDBox>
      <MDBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <MDTypography
                component="label"
                variant="button"
                fontWeight="regular"
                color="text"
              >
                Isi instruksi&nbsp;&nbsp;
                <MDTypography variant="caption" color="text">
                  (wajib diisi)
                </MDTypography>
              </MDTypography>
            </MDBox>

            <TextField
              fullWidth
              multiline
              rows={6}
              value={values.isi_instruksi || ""}
              onChange={handleTextFieldChange}
              variant="outlined"
              placeholder="Masukkan isi instruksi..."
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MDBox mb={3}>
              <MDBox mb={2} display="inline-block">
                <MDTypography
                  component="label"
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  textTransform="capitalize"
                >
                  Prioritas
                </MDTypography>
              </MDBox>
              <Autocomplete
                value={values.prioritas}
                onChange={handleAutoChange("prioritas")}
                options={["Rendah", "Sedang", "Tinggi"]}
                renderInput={(params) => (
                  <MDInput {...params} variant="standard" />
                )}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default Instruksi;
